// extracted by mini-css-extract-plugin
export default {"modalCard":"MainCeremonyPhotoModal_modalCard__RlYu+","title":"MainCeremonyPhotoModal_title__9AGa-","photoList":"MainCeremonyPhotoModal_photoList__gMc5x"};